import { apiGet, apiGetBlob, apiPostForm, apiDelete } from "./apiClient";

export function createCustomerTransactionSchedule(payload) {
    const formData = new FormData();

    const data = {
        requestNumber: payload.requestNumber,
        institutionId: payload.institutionId,
        registrationDateTime: payload.registrationDateTime,
        requestDateTime: payload.requestDateTime,
        currency: payload.currency,
        paymentAmount: payload.paymentAmount,
        beneficiaryCompany: payload.beneficiaryCompany,
        beneficiaryBank: payload.beneficiaryBank,
        beneficiaryAccount: payload.beneficiaryAccount,
        paymentPurpose: payload.paymentPurpose,
    };

    formData.append(
        "data",
        new Blob([JSON.stringify(data)], { type: "application/json" })
    );

    formData.append("invoiceFile", payload.invoiceFile);
    formData.append("contractFile", payload.contractFile);

    return apiPostForm("/customer-transaction-schedules", formData);
}

export function getMyCustomerTransactionSchedules() {
    return apiGet("/customer-transaction-schedules/my");
}

export function getCustomerTransactionScheduleDetail(id) {
    return apiGet(`/customer-transaction-schedules/${id}`);
}

export function downloadInvoicePdf(id) {
    return apiGetBlob(`/customer-transaction-schedules/${id}/invoice`);
}

export function downloadContractPdf(id) {
    return apiGetBlob(`/customer-transaction-schedules/${id}/contract`);
}

export function previewCustomerTransactionExcel(file) {
    const formData = new FormData();
    formData.append("file", file);
    return apiPostForm("/customer-transaction-schedules/excel/preview", formData);
}

export function importCustomerTransactionExcel(formData) {
    return apiPostForm("/customer-transaction-schedules/excel/import", formData);
}

export function deleteCustomerTransactionSchedule(id) {
    return apiDelete(`/customer-transaction-schedules/${id}`);
}

export function downloadGeneratedAllocationSlipPdf(allocationId) {
    return apiGetBlob(`/customer-transaction-schedules/allocations/${allocationId}/generated-slip-pdf`);
}

export function downloadGeneratedAllocationSampleFilledPdf(allocationId) {
    return apiGetBlob(`/customer-transaction-schedules/allocations/${allocationId}/generated-sample-filled-pdf`);
}

export function downloadScannedLatestSlipPdf(allocationId) {
    return apiGetBlob(`/customer-transaction-schedules/allocations/${allocationId}/scanned-latest-slip-pdf`);
}

export function downloadScannedLatestSampleFilledPdf(allocationId) {
    return apiGetBlob(`/customer-transaction-schedules/allocations/${allocationId}/scanned-latest-sample-filled-pdf`);
}